import React from "react";
import { FormHelperText, TextField } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./FormTextField.css";
import { Dayjs } from "dayjs";

interface FormDateFieldProps {
  value: Dayjs | null;
  label: string;
  handleDateChange: (date: Dayjs | null) => void;
  expiryError: string;
  isMandatory?: boolean;
}

const FormDateField: React.FC<FormDateFieldProps> = ({
  value,
  label,
  handleDateChange,
  expiryError,
  isMandatory = false,
}) => {
  return (
    <div className="FormTextField">
      <div className="FormTextField_label">
        {label}
        {isMandatory && <span style={{ color: "red" }}>*</span>}
      </div>
      <div className="DatePicker_container">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            inputFormat="DD/MM/YYYY"
            value={value}
            onChange={handleDateChange}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                size="small"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: expiryError ? "#d32f2f" : "#EAEAEA",
                    },
                    "&:hover fieldset": {
                      borderColor: "#B9B9B9",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#1C7EA0",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: expiryError ? "#d32f2f" : "#B5B5B5",
                    fontSize: "13px",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#1C7EA0",
                  },
                }}
              />
            )}
          />
        </LocalizationProvider>
        {expiryError && (
          <FormHelperText sx={{ position: "absolute", bottom: "-20px" }} error>
            {expiryError}
          </FormHelperText>
        )}
      </div>
    </div>
  );
};

export default FormDateField;
